import { FORMAT, formatDateTime } from "Common/dateTimeUtils/format";
import React, { memo } from "react";
import classNames from "classnames";
function Author({ data, defaultSrc, defaultTitle, imgSize, url }) {
    const content = (React.createElement(React.Fragment, null,
        React.createElement("img", { className: "border-rounded-circle", width: imgSize, height: imgSize, src: data.AuthorImage || defaultSrc, alt: data.AuthorName || defaultTitle }),
        React.createElement("div", { className: classNames("ml-0_5 flex-single-column", url && "link-default") },
            React.createElement("div", null, data.AuthorName || defaultTitle),
            React.createElement("div", { className: "label" }, formatDateTime(data.Created, FORMAT.DATE_TIME)))));
    if (url) {
        return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", className: "d-flex v-center-items", style: { textDecoration: "none", color: "inherit" } }, content));
    }
    return React.createElement("div", { className: "d-flex v-center-items" }, content);
}
export default memo(Author);
